var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackerDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1,.prefix__cls-4{fill:none}.prefix__cls-1,.prefix__cls-2{stroke:#000}.prefix__cls-2{fill:#fff}.prefix__cls-3{stroke:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_361",
    "data-name": "Group 361",
    transform: "translate(-1013 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_63",
    className: "prefix__cls-1",
    "data-name": "Ellipse 63",
    transform: "translate(1013 861)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41,
    className: "prefix__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_358",
    "data-name": "Group 358",
    transform: "translate(12711.2 17950.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_81",
    className: "prefix__cls-1",
    "data-name": "Rectangle 81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H23.587V23.587H0z",
    className: "prefix__cls-3",
    transform: "translate(-11668.822 -17061.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H23.087V23.087H0.5z",
    className: "prefix__cls-4",
    transform: "translate(-11668.822 -17061.318)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_107",
    d: "M-11548.5-17035h7.481l4.334 6.123v8.8h-11.815",
    className: "prefix__cls-1",
    "data-name": "Path 107",
    transform: "translate(-97.126 -19.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_108",
    d: "M-11548.5-17009h11.815",
    className: "prefix__cls-1",
    "data-name": "Path 108",
    transform: "translate(-97.126 -38.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_109",
    d: "M-11548.5-17009h6.563",
    className: "prefix__cls-1",
    "data-name": "Path 109",
    transform: "translate(-131.7 -40.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_110",
    d: "M-11548.5-17009h6.563",
    className: "prefix__cls-1",
    "data-name": "Path 110",
    transform: "translate(-131.7 -45.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_111",
    d: "M-11548.5-17009h6.563",
    className: "prefix__cls-1",
    "data-name": "Path 111",
    transform: "translate(-131.7 -36.12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_56",
    className: "prefix__cls-2",
    "data-name": "Ellipse 56",
    transform: "translate(-11643.848 -17041.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.162,
    cy: 4.162,
    r: 4.162,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.162,
    cy: 4.162,
    r: 3.662,
    className: "prefix__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_57",
    className: "prefix__cls-2",
    "data-name": "Ellipse 57",
    transform: "translate(-11661.885 -17041.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.162,
    cy: 4.162,
    r: 4.162,
    className: "prefix__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.162,
    cy: 4.162,
    r: 3.662,
    className: "prefix__cls-4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerDelivery);
export default __webpack_public_path__ + "static/media/tracker-delivery.238d47fd5ed40ee24bab3bcc9f046ddf.svg";
export { ForwardRef as ReactComponent };